module.exports = __webpack_public_path__ + "img/2-3.cf1012d6.png";